module.exports = __webpack_public_path__ + "static/media/vermi_immunity.b4149c61.png";